import React, { useEffect, useState } from "react";
import { useAuth } from 'components/authentication/signup-login/AuthContext';
import AuthModalHandler from 'components/authentication/signup-login/AuthModalHandler';
import { useSelector, useDispatch } from "react-redux";
import { saveCharts } from "../../../../store/workspaceSlice";

function SaveCharts({ className, payload, formattedPayload, path, reduxPayload }) {
    const dispatch = useDispatch();
    const { login, isAuthenticated } = useAuth();
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [savedpop, setSavedPop] = useState(false);
    const [chartName, setChartName] = useState("");

    // Open modal — only if authenticated
    const handleOpenModal = () => {
        if (!isAuthenticated) {
            setShowAuthModal(true);
            return;
        }
        setModalOpen(true);
    };
    const handleLoginSuccess = (response) => {
        const loginData = response.data || response;
        let userData = null;
        let token = null;

        if (loginData && loginData.user) {
            userData = loginData.user;
            token = loginData.token;
        } else {
            // Handle different response structures
            userData = {
                name: response.name || response.user?.name || 'User',
                email: response.email || response.user?.email || 'user@example.com'
            };
            token = response.token || response.access_token;
        }
        login(userData, token);
        setShowAuthModal(false);

    };

    // Save chart
    const handleFinalSave = () => {
        if (!chartName.trim()) {
            alert("Please enter a chart name.");
            return;
        } setModalOpen(false)

        const saveChartData = {
            payload,
            formattedPayload,
            chartName,
            path,
            reduxPayload,
            savedAt: new Date().toISOString()
        };
        dispatch(saveCharts(saveChartData));
        setChartName("");
        setSavedPop(true);
    };

    return (
        <>
            {/* Save Chart Button */}
            <button className={`btn btn-primary btn-sm  ${className}`} onClick={handleOpenModal}>
                Save Chart
            </button>

            {/* Modal */}
            {isModalOpen && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)",
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            {/* Header */}
                            <div className="modal-header">
                                <h5 className="modal-title">Save Chart</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setModalOpen(false)}
                                ></button>
                            </div>

                            {/* Body */}
                            <div className="modal-body">
                                <label className="form-label">Enter chart name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Chart Name"
                                    value={chartName}
                                    onChange={(e) => setChartName(e.target.value)}
                                />
                            </div>

                            {/* Footer */}
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setModalOpen(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleFinalSave}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {savedpop && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)",
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            {/* Header */}
                            <div className="modal-header">
                                <h5 className="modal-title">Chart successfully saved to Workspace!</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setSavedPop(false)}
                                ></button>
                            </div>

                            {/* Body */}
                            <div className="modal-body">
                                <p><b><i className="fw-bold">Note:</i></b> Make sure to save or update your workspace to save the chart for future reference.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Auth Modal for login when user tries to save without being logged in */}
            <AuthModalHandler
                show={showAuthModal}
                handleClose={() => {
                    setShowAuthModal(false);
                }}
                initialMode="login"
                onLoginSuccess={handleLoginSuccess}
            />
        </>
    );
}

export default SaveCharts;
